module.exports = __webpack_public_path__ + "static/media/book_demo.5415f3e1.svg";